import styled from 'styled-components'
import InputTags from "./component";

export default styled(InputTags)`
    background: green
`;